import { render } from "./EditInput.vue?vue&type=template&id=8da4629e"
import script from "./EditInput.vue?vue&type=script&lang=js"
export * from "./EditInput.vue?vue&type=script&lang=js"

import "./EditInput.vue?vue&type=style&index=0&id=8da4629e&lang=css"
script.render = render

export default script